@if (ready) {
  <div class="heatmap" style="max-height: 200px;">
    <ngx-charts-line-chart #chart1 class="dark"
      [scheme]="colorScheme"
      [results]="voiceChartData"
      [xAxis]="xAxis"
      [yAxis]="yAxis"
      [legend]="legend"
      [curve]="curve"
      [showXAxisLabel]="showXAxisLabel"
      [showYAxisLabel]="showYAxisLabel"
      [yScaleMin]="min"
      [yScaleMax]="max"
      [autoScale]="autoScale"
      [animations]="animations"
      [showGridLines]="showGridLines"
      [roundDomains]="roundDomains">
    </ngx-charts-line-chart>
  </div>
}
@if (ready) {
  <div class="heatmap" style="max-height: 120px;">
    <ngx-charts-line-chart #chart1 class="dark"
      [scheme]="colorScheme2"
      [results]="segmentsChartData"
      [xAxis]="xAxis"
      [yAxis]="yAxis"
      [legend]="legend"
      [curve]="curve"
      [showXAxisLabel]="showXAxisLabel"
      [showYAxisLabel]="showYAxisLabel"
      [yScaleMin]="min"
      [yScaleMax]="max"
      [autoScale]="autoScale"
      [animations]="animations"
      [showGridLines]="showGridLines"
      [roundDomains]="roundDomains">
    </ngx-charts-line-chart>
  </div>
}
@if (!ready) {
  <div class="d-flex justify-content-center align-items-center" style="height: 320px;">
    <app-loading-spinner></app-loading-spinner>
  </div>
}